/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { workspacesGetStorageStats } from "../../funcs/workspacesGetStorageStats.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .GetApiWorkspaceServiceV1WorkspacesStorageStatsWorkspaceIdRequest$inboundSchema,
};

export const tool$workspacesGetStorageStats: ToolDefinition<typeof args> = {
  name: "workspaces_get-storage-stats",
  description: `Get storage statistics`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await workspacesGetStorageStats(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
